import { VuexModule, Module, Action, Mutation } from 'vuex-module-decorators'
import { ApiClient } from "@sfs-projects/sfs-fc-api-sdk";

@Module({ namespaced: true })
class ConfigurationsModule extends VuexModule {
  public EmailConfigurations: Array<string> = [];
  public PaymentTerms: Array<string> = [];
  public InvoiceStatuses: Array<string> = [];
  public Environments: Array<any> = [];
  public Currencies: Array<object> = [];
  public ExactConfig: object = {};
  public ExtendisConfig: object = {};
  public ListCurrency: Array<string> = [];

  @Mutation
  public setConfig(config: any) {
    this.EmailConfigurations =  config.EmailConfigurations;
    this.PaymentTerms =  config.PaymentTerms;
    this.InvoiceStatuses =  config.InvoiceStatuses;
    this.Environments =  config.Environments;
    this.Currencies =  config.Currencies;
    this.ExactConfig =  config.ExactConfig;
    this.ExtendisConfig =  config.ExtendisConfig;
    this.ListCurrency = config.ListCurrency;
  }

  @Action
  public async saveConfig(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      ApiClient.put('configuration', data).then((response: any) => {
        if (response.success) {
          const result = response.data[0];
          this.context.commit('setConfig', result);
          resolve(result);
        }
        resolve({ Error: response.data });
      }, error => {
        reject(error);
      });
    });
  }

  @Action
  public async getConfig(): Promise<any> {
    return new Promise((resolve, reject) => {
      ApiClient.get('configuration').then((response: any) => {
        if (response.success) {
          const result = response.data[0];
          this.context.commit('setConfig', result);
          resolve(result);
        }
        resolve({ Error: response.data });
      }, error => {
        reject(error);
      });
    });
  }
}

export default ConfigurationsModule